import React from 'react';
import { motion } from 'framer-motion';
import { MenuItem } from './MenuItem';
import Separator from './Separator';
import styled from 'styled-components';
import { withLanguage } from '../i18n/LanguageContext';

const variants = {
  open: {
    overflowY: 'auto',
    transition: { staggerChildren: 0.03, delayChildren: 0.2 },
  },
  closed: {
    overflowY: 'hidden',
    transition: { staggerChildren: 0.02, staggerDirection: -1 },
  },
};

const List = styled(motion.ul)`
  margin: 0;
  opacity: 0.8;
  padding: 0 2em 2em;
  width: 100%;
  overflow: hidden;
  overflow-y: auto;
`;

const Navigation = ({ onClick, content: { rooms, navigation } }) => (
  <List variants={variants}>
    <MenuItem to={'/#welcome'} label={navigation.welcome} onClick={onClick} />
    <MenuItem to={'/#rooms'} label={navigation.rooms} onClick={onClick} />
    <MenuItem to={'/#dining'} label={navigation.dining} onClick={onClick} />
    <MenuItem to={'/promotions'} label={navigation.promotions} onClick={onClick} />
    <Separator />
    {rooms.map(({ id, title }) => (
      <MenuItem key={id} to={`/room/${id}`} label={title} onClick={onClick} />
    ))}
    <Separator />
    <MenuItem to={`/restaurant/shanghai`} label={navigation.shanghai} onClick={onClick} />
    {/*<MenuItem*/}
    {/*  to={`/restaurant/lavilla`}*/}
    {/*  label={navigation.lavilla}*/}
    {/*  onClick={onClick}*/}
    {/*/>*/}
    <Separator />
    <MenuItem to={'/#footer'} label={navigation.footer} onClick={onClick} />
  </List>
);

export default withLanguage(Navigation);
